import HelpScreen from "./index";

const routes = [
  {
    path: "/help",
    component: HelpScreen,
  },
];

export default routes;
